import { Box, Chip, Typography } from '@mui/material';

import { runSummaryAgentReportStyles } from './styles/runSummaryAgentReportStyles';

export default function TriagePriorities({ items = [] }) {
  if (!items.length) return null;

  return (
    <Box sx={runSummaryAgentReportStyles.reportPanel}>
      <Typography variant="subtitle2" sx={runSummaryAgentReportStyles.sectionTitle}>
        Triage Priorities
      </Typography>
      <Box sx={runSummaryAgentReportStyles.insightStack}>
        {items.map((item, index) => (
          <Box
            key={`${item.priority || 'priority'}-${item.area || index}`}
            sx={runSummaryAgentReportStyles.priorityItem}
          >
            <Box sx={runSummaryAgentReportStyles.panelTitleRow}>
              <Typography variant="body2" sx={runSummaryAgentReportStyles.insightTitle}>
                {item.area || 'Selected scope'}
              </Typography>
              {item.priority && (
                <Chip
                  size="small"
                  label={item.priority}
                  sx={runSummaryAgentReportStyles.statusChip}
                />
              )}
            </Box>
            <Typography variant="body2" color="text.secondary">
              {item.reason}
            </Typography>
            {item.suggestedAction && (
              <Typography variant="body2" mt={0.75}>
                {item.suggestedAction}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
